
import React, { useState, useEffect } from "react";
import "./BoxButton.css";
import { 
  FaPencilAlt, 
  FaEye, 
  FaTrash, 
  FaCheck, 
  FaTimes, 
  FaRegEyeSlash, 
  FaChevronDown, 
  FaChevronUp 
} from "react-icons/fa";

export default function BoxButton({ type, onClick, inquiry, onViewToggle, expanded }) {
  const [viewed, setViewed] = useState(false);

  // ✅ Check backend if this request is already viewed
  useEffect(() => {
    if (type === "view" && inquiry) {
      const token = sessionStorage.getItem("token");
      if (!token) return;

      async function fetchViewedStatus() {
        try {
          const res = await fetch(`api/views/check/${inquiry.id}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const data = await res.json();
          if (data.viewed) setViewed(true);
        } catch (err) {
          console.error("Error fetching view status:", err);
        }
      }

      fetchViewedStatus();
    }
  }, [type, inquiry]);

  let Icon;
  let label;
  let className = "bb-panel-button";

  switch (type) {
    case "edit":
      Icon = FaPencilAlt;
      label = "Edit";
      className += " bb-edit";
      break;
    case "view":
      Icon = viewed ? FaRegEyeSlash : FaEye;
      label = viewed ? "Viewed" : "View";
      className += " bb-view";
      break;
    case "delete":
      Icon = FaTrash;
      label = "Delete";
      className += " bb-delete";
      break;
    case "save":
      Icon = FaCheck;
      label = "Save";
      className += " bb-save";
      break;
    case "cancel":
      Icon = FaTimes;
      label = "Cancel";
      className += " bb-cancel";
      break;
    case "expand":
      Icon = expanded ? FaChevronUp : FaChevronDown;
      label = expanded ? "Collapse" : "Expand";
      className += " bb-expand";
      break;
    default:
      return null;
  }

  const handleViewClick = async () => {
    if (!inquiry) return;
    const token = sessionStorage.getItem("token");
    if (!token) return;

    try {
      if (!viewed) {
        const res = await fetch("api/views/add", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ requestId: inquiry.id }),
        });
        const data = await res.json();
        if (data.success) {
          setViewed(true);
          if (onViewToggle) onViewToggle(inquiry.id, true);
        }
      } else {
        const res = await fetch("api/views/remove", {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ requestId: inquiry.id }),
        });
        const data = await res.json();
        if (data.success) {
          setViewed(false);
          if (onViewToggle) onViewToggle(inquiry.id, false);
        }
      }
    } catch (err) {
      console.error("Error updating view status:", err);
    }
  };

  return (
    <button
      className={className}
      onClick={() => {
        if (type === "view") handleViewClick();
        if (onClick) onClick();
      }}
    >
      <Icon className="ci-panel-button-icon" />
      <span>{label}</span>
    </button>
  );
}
